//设备管理
const Management = () =>
  import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/lora-lock/index.vue"); //lora地磁
const Station = () =>
  import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/station.vue");
//网关日志
const StationLog = () =>
  import(
    /*webpackChunkName:'itil'*/ "@/page/itil/equipment/station-log/station-log.vue"
  ); //网关
const NbGeomagnetism = () =>
  import(
    /*webpackChunkName:'itil'*/ "@/page/itil/equipment/nbGeomagnetism.vue"
  ); //地磁
const EquipWarn = () =>
  import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/equipWarn.vue");
const IntellidataDevice = () =>
  import(
    /*webpackChunkName:'itil'*/ "@/page/itil/equipment/intellidataDevice.vue"
  ); //高位视频管理
const PatrolCar = () =>
  import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/patrolCar.vue"); //巡逻车
//lora地锁定时任务
const LoraTask = () =>
    import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/lora-lock/task.vue"); 

//nb地锁
const NbLock = () =>
    import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/nb-lock/nb-lock.vue");

//nb地锁报警
const NbLockWarn = () =>
    import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/nb-lock-warn.vue");

//报警主页面（整合地磁和地锁报警）
const AlarmMain = () =>
    import(/*webpackChunkName:'itil'*/ "@/page/itil/equipment/alarm-main.vue");

const RouteTemp = () => import("@/page/commons/routeTemp.vue");

export const deviceManagement = {
  path: "/main/equipment",
  name: "设备管理",
  component: RouteTemp,
  children: [
    {
      path: 'data-overview',
      name: '数据概览',
      component: () => import('@/page/device/data-overview/data-overview.vue'),
      meta: {
        requireAuth: true,
        title: '数据概览'
      }
    },
    {
      path: "/main/equipment/station",
      name: "网关管理",
      component: Station,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/equipment/station/log",
      name: "网关日志",
      component: StationLog,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/equipment/management",
      name: "lora地锁",
      component: Management,
      meta: {
        requireAuth: true,
      },
    },
    {
        path: "/main/equipment/lora-lock/task",
        name: "lora地锁定时任务",
        component: LoraTask,
        meta: {
          requireAuth: true,
        },
      },
    {
      path: "/main/equipment/intellidataDevice",
      name: "高位视频管理",
      component: IntellidataDevice,
      meta: {
        requireAuth: true,
      },
    },

    {
      path: "/main/equipment/nbGeomagnetism",
      name: "地磁",
      component: NbGeomagnetism,
      meta: {
        requireAuth: true,
      },
    },
     {
      path: "/main/equipment/nb-lock",
      name: "车位锁",
      component: NbLock,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/equipment/patrol-car",
      name: "巡逻车",
      component: PatrolCar,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/equipment/alarm",
      name: "报警管理",
      component: AlarmMain,
      meta: {
        requireAuth: true,
      },
    },
    // 保留原路由以便兼容（可选）
    {
      path: "/main/equipment/equipWarn",
      name: "NB地磁报警",
      component: EquipWarn,
      meta: {
        requireAuth: true,
      },
    },
     {
      path: "/main/equipment/nb-lock-warn",
      name: "NB地锁报警",
      component: NbLockWarn,
      meta: {
        requireAuth: true,
      },
    },
  ],
};
